
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>都道府県</label>
        <dropdown v-model="searchForm.model.prefecture" @change="onPrefectureChange()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">
            {{ each.label }}
          </option>
        </dropdown>
      </div>
      <div class="field">
        <label>エリア</label>
        <dropdown v-model="searchForm.model.area" @change="search()" :placeholder="'すべて'">
          <option value="">すべて</option>
          <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">
            {{ each.label }}
          </option>
        </dropdown>
      </div>
      <div class="six wide field">
        <label>店舗名 / TEL</label>
        <div class="ui action input">
          <input v-model="searchForm.model.q" type="text" placeholder="検索条件">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <pagination :pager="pager" :callback="search"></pagination>
    <table class="ui compact selectable table">
      <thead>
        <tr>
          <th class="shop-id">店舗ID</th>
          <th>都道府県</th>
          <th>エリア</th>
          <th>店舗名</th>
          <th>TEL</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="shop in shops" :key="shop.id">
          <td class="shop-id">{{ shop.id }}</td>
          <td>{{ shop.prefecture_name }}</td>
          <td>{{ shop.area_name }}</td>
          <td>{{ shop.name }}</td>
          <td>{{ shop.tel }}</td>
          <td class="actions">
            <a class="clickable" :href="shop.auth_url" target="_blank">店舗ページへ</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
